class FooterApp extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(window, 'load', this.handleTrigger)
  }

  handleTrigger () {
    const getMobileOS = () => {
      const ua = navigator.userAgent
      if (/android/i.test(ua)) {
        return 'Android'
      } else if (/iPad|iPhone|iPod/.test(ua) && navigator.maxTouchPoints > 1) {
        return 'iOS'
      }
      return 'Other'
    }
    const mobileOS = getMobileOS()

    if (mobileOS === 'Android') {
      this.els.link.element.setAttribute(
        'href',
        window.theme.appDownload.android,
      )
    } else if (mobileOS === 'iOS') {
      this.els.link.element.setAttribute('href', window.theme.appDownload.ios)
    }
  }
}

if (!customElements.get('footer-app')) {
  customElements.define('footer-app', FooterApp)
}
